import { Operator } from '../model/operator';
import { FieldType } from '../../settings/model/field-type';
import { DataSourceField, DataSource } from '../model/data-source';
import { Sort, SortDirection } from '../model/transformations';

export function getOperators(fieldType: FieldType, jsonpath: string = null): Operator[] {
  if (jsonpath && jsonpath.startsWith('$.extra_data.')) {
    switch (fieldType) {
      case FieldType.INTEGER:
      case FieldType.FLOAT:
        return [Operator.equals, Operator.greaterThan, Operator.lessThan];
      default:
        return [Operator.equals];
    }
  }

  switch (fieldType) {
    case FieldType.TEXT:
      return [Operator.iEquals, Operator.iNotEqual,
      Operator.iContains, Operator.iNotContains,
      Operator.iStartsWith, Operator.iEndsWith,
      Operator.isNull, Operator.notNull];
    case FieldType.BOOLEAN:
      return [Operator.equals, Operator.notEqual];
    case FieldType.INTEGER:
    case FieldType.FLOAT:
      return [Operator.equals, Operator.notEqual,
      Operator.greaterThan, Operator.greaterOrEqual,
      Operator.lessThan, Operator.lessOrEqual,
      Operator.between, Operator.betweenInclusive,
      Operator.isNull, Operator.notNull];
    case FieldType.DATE:
      return [Operator.equals, Operator.betweenInclusive];
    case FieldType.DATETIME:
      return [Operator.betweenInclusive, Operator.between, Operator.equals];
    case FieldType.TIME:
      return [Operator.betweenInclusive, Operator.between];
    case FieldType.AREA:
      return [Operator.contains, Operator.notContains];
    case FieldType.ENUM:
      return [Operator.equals, Operator.notEqual];
    case FieldType.VEHICLE_GROUP:
      return [Operator.iEquals, Operator.iNotEqual];
    case FieldType.VIOLATIONS_MARKER:
    case FieldType.VIOLATIONS_MARKER_2:
    case FieldType.DISPUTE_STATUS_FILTER:
    case FieldType.CONTRACT:
      return [Operator.equals, Operator.notEqual, Operator.isNull, Operator.notNull];
    case FieldType.VIOLATION_WITH_STATUS:
      return [Operator.equals, Operator.notEqual];
    default:
      return [Operator.equals];
  }
}

export function mutateData<T>(data: T, mutableFields?: DataSourceField[]): void {
  if (mutableFields?.length) {
    mutableFields.forEach(field => {
      field.column.mutate(data, field.valueField.fieldName || field.valueField.name);
    });
  }
}

export function mutateDataArray<T>(data: T[], mutableFields?: DataSourceField[]): void {
  if (mutableFields?.length) {
    data.forEach(element => mutateData(element, mutableFields));
  }
}

export function pkBasedKeyGenerator<T>(dataSource: DataSource): ((data: T) => any) {
  const pk = dataSource.fields.filter(field => field.valueField.primaryKey);
  return (data: T) => {
    const key = {};
    pk.forEach(field => key[field.column.name] = data[field.column.name]);
    return key;
  };
}

export function toColumnSortersArray(sort?: Sort[]): string[] | null {
  if (sort) {
    return sort.map(sortObject => (sortObject.direction == SortDirection.DESC ? '-' : '') + sortObject.active);
  }
  return null;
}
